import BinaryReader from './src/BinaryReader'
import BinaryWriter from './src/BinaryWriter'
import NotifyMsgHeader from './src/NotifyMsgHeader'
import NotifyMsgTail from './src/NotifyMsgTail'
import Block from './src/Block'
import NotifyMsg from './src/NotifyMsg'
import NotifyClient from './src/NotifyClient'
import Socket from './src/Socket'
import TcpSocket from './src/TcpSocket'
import UdpSocket from './src/UdpSocket'

const global = window || {};

const ZJNotify = {
    BinaryReader,
    BinaryWriter,
    NotifyMsgHeader,
    NotifyMsgTail,
    Block,
    NotifyMsg,
    NotifyClient,
    Socket,
    TcpSocket,
    UdpSocket
};

const install = function(Vue, opts) {
    global.ZJNotify = ZJNotify;
    global.$notify = global.ZJApp.notify = global.$notify || new ZJNotify.NotifyClient(opts);
    Vue.prototype.$notify = global.$notify;
}

export default {
    install,
    ...ZJNotify
};
